<template>
  <div>
    <!-- TODO add a loader -->
  </div>
</template>

<script>
export default {
  name: 'IncomingView',
  emits: ['openModal', 'openNotification'],
  data: () => ({
    idLanding: null,
    campaignCode: null,
    token: null,
    order: false
  }),
  created() {
    this.preload()
  },
  methods: {
    async preload() {
      this.$store.$reset()

      this.processQueryParams()

      try {
        const res = await this.$api.getGenders()
        this.$store.setGenders(res.data)

        if (this.token) {
          //! recall
          const res = await this.$api.getRecallCampaign(this.token)
          if (res.data.user?.is_blocked_user) {
            this.$store.setMessageError('Votre compte est désactivé')
            this.$router.push({ name: 'error' })
            return
          }
          if (res.data.winner?.token) {
            this.$store.setCampaign(res.data.campaign)
            this.$store.setProducts(res.data.products)
            this.$store.setParticipationCodes(res.data.codes)
            this.$store.setWinnerData({
              token: res.data.winner.token,
              email: res.data.winner.email,
              voucher: res.data.winner.voucher,
              isWinner: true,
            })
            this.$store.setOptinVariant(res.data.winner.optin_variant)
            this.$store.updateCart(res.data.winner.cart)
            this.$router.replace({ name: 'product' })
            return
          } else{
            this.$store.clearWinnerData()
          }

          this.$store.setCampaign(res.data.campaign)
          this.$store.setProducts(res.data.products)
          this.$store.setParticipationCodes(res.data.codes)
          this.$store.setUser(res.data.user)
          this.$store.setParticipation(res.data.participation)
          if (this.order) {
            this.$router.replace({ name: 'product' })
            return
          }


          if (this.$template.is_landing) {
            this.$router.replace({
              name: 'landing',
            })
            return
          }
          if (this.$template.mandatory_purchase) {
            if (this.$template.is_entry) {
              this.$router.replace({
                name: 'acquisition-purchase',
                params: { campaignCode: this.$campaign.code }
              })
            } else {
              this.$router.replace({ name: 'product' })
            }
          } else {
            this.$router.replace({
              name: 'acquisition',
              params: { campaignCode: this.$campaign.code }
            })
          }
        } else {
          //! aquisition
          const res = await this.$api.getAcquisitionCampaign(this.idLanding)
          this.$store.setCampaign(res.data.campaign)
          this.$store.setParticipationCodes(res.data.codes)
          this.$store.setProducts(res.data.products)
          this.$store.setOptinVariant(res.data.optin_variant)

          if (window.OptinTracking && !window.location.href.includes('localhost') && this.$store.utms['var_oc']) {
            const affiliateCampaignId = "auto";
            const t = new window.OptinTracking({ affiliateCampaignId });
            t.init(); // Lancement du tracking après validation
            console.log("Tracking incoming");
          }

          if (this.$template.is_landing) {
            this.$router.replace({
              name: 'landing',
            })
          } else {
            this.$router.replace({
              name: 'acquisition',
              params: { campaignCode: this.$campaign.code },
              query: this.$store.utms
            })
          }
        }
      } catch (e) {
        // todo pourquoi e.response peut ne pas exister ?
        this.$store.setMessageError(
          e.response?.data?.message ? e.response.data.message : 'Lien non valide'
        )
        console.error(e)
        this.$router.push({ name: 'error' })
        // alert('redirect-to-error')
        // this.redirectErrorPage()
      }
    },
    processQueryParams() {
      Object.entries(this.$route.query).forEach(([key, value]) => {
        switch (key) {
          case 'course':
            this.idLanding = value
            this.$store.idLanding = value
            break
          case 'campaign':
            this.campaignCode = value
            break
          case 'token':
            this.token = value
            break
          case 'order':
            this.order = value
            break
          case 'recall_2':
            this.$store.recall2 = true
            break
          case 'preview':
            this.token = value
            this.$store.isPreview = true
            break
          case 'gender':
            this.$store.genderGet = value
            break
          case 'email':
            this.$store.emailGet = value
            break
          case 'firstname':
            this.$store.firstnameGet = value
            break
          case 'lastname':
            this.$store.lastnameGet = value
            break
          case 'dateofbirth':
            this.$store.dateofbirthGet = value
            break
          case 'zipcode':
            this.$store.zipcodeGet = value
            break
          case 'phone':
            this.$store.phoneGet = value
            break
          default:
            if (key.startsWith('utm') || ['cd1', 'cd3', 'var_oc', 'aff_sub2', 'click_id', 'cid', 'utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content'].includes(key)) {
              this.$store.utms[key] = value
            }
        }
      })
    },
    redirectErrorPage() {
      this.$router.push({ name: 'error' })
    }
  }
}
</script>
